/* eslint-disable @typescript-eslint/naming-convention */
import { Flex, Text } from '@servicetitan/anvil2';
import document from '../../common/illustrations/unable-to-load.svg';
import { ProviderDisclosures } from '@servicetitan/financing-provider-assets';

export const SignatureNotReceived = () => {
    return (
        <Flex direction="column" alignItems="center" gap="3" style={{ maxWidth: '845px' }}>
            <img src={document} />
            <Text variant="headline" el="h3">
                Signature not received
            </Text>
            <Text
                dangerouslySetInnerHTML={{ __html: ProviderDisclosures.serviceFinance.notReceived }}
            />
        </Flex>
    );
};
